export const IdeEnum = {
    MakeCode: 1,
    Scratch: 2,
    Edubot:3,
    Zcode:4
}